import React from "react";
import { Header } from "semantic-ui-react";
import { getDescripcionMetodoPago } from "../../../../app/util/textCodeUtils";

const PagarPrestamosResumenHeader = ({ metodoPago }) => {
  return (
    <Header
      as="h4"
      color="blue"
      content={`Pago Cuota - ${getDescripcionMetodoPago(metodoPago)}`}
    />
  );
};

export default PagarPrestamosResumenHeader;
